import React from 'react'
import '../../../css/Category/Vegan.scss'

function Vegan({active}) {
    return (
        <div className={active === true ? 'Vegan active' : 'Vegan'}>
            <div
                style={{
                    width: 60,
                    height: 60,
                    overflow: "hidden",
                    display: "block",
                }}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 760 760"
                    width={760}
                    height={760}
                    preserveAspectRatio="xMidYMid meet"
                    style={{
                        width: "100%",
                        height: "100%",
                        transform: "translate3d(0px, 0px, 0px)"
                    }}
                >
                    <defs>
                        <clipPath id="__lottie_element_562">
                            <rect width={760} height={760} x={0} y={0} />
                        </clipPath>
                    </defs>
                    <g clipPath="url(#__lottie_element_562)">
                        <g
                            className='g-1'
                            transform="matrix(-0.008818035013973713,0.19980551302433014,-0.19980551302433014,-0.008818035013973713,446.68359375,327.6325378417969)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,189.6909942626953,-1.996000051498413)"
                            >
                                <path
                                    fill="rgb(209,240,246)"
                                    fillOpacity={1}
                                    d=" M91.94999694824219,-115.8219985961914 C-12.026000022888184,-212.36300659179688 -133.0540008544922,-232.31300354003906 -228.39300537109375,-169.7830047607422 C-296.0580139160156,-136.11399841308594 -321.489990234375,-25.889999389648438 -276.3580017089844,68.33200073242188 C-254.0590057373047,114.88600158691406 -194.72300720214844,203.66099548339844 -87.9209976196289,252.48699951171875 C-60.49300003051758,265.0260009765625 123.90599822998047,301.30499267578125 196.44700622558594,222.50799560546875 C242.10899353027344,172.90699768066406 222.40699768066406,58.90700149536133 196.44700622558594,11.800999641418457 C176.9550018310547,-23.56800079345703 143.6060028076172,-67.86000061035156 91.94999694824219,-115.8219985961914z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-2'
                            transform="matrix(1,0,0,1,235.49200439453125,533.4759521484375)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,150.16400146484375,58.10300064086914)"
                            >
                                <path
                                    fill="rgb(201,227,235)"
                                    fillOpacity={1}
                                    d=" M-150.14999389648438,-2.7139999866485596 C-150.6009979248047,-15.263999938964844 -140.54200744628906,-28.187000274658203 -119.4469985961914,-39.672000885009766 C-96.4000015258789,-52.22100067138672 -64.23300170898438,-58.542999267578125 -24.24799919128418,-58.07899856567383 C42.0369987487793,-57.310001373291016 96.28600311279297,-47.7760009765625 131.08599853515625,-25.05299949645996 C143.7830047607422,-16.76300048828125 151.21800231933594,-7.7779998779296875 150.04200744628906,1.937999963760376 C149.41000366210938,7.164000034332275 145.52699279785156,12.277000427246094 139.2949981689453,16.892000198364258 C121.1760025024414,30.30900001525879 98.40499877929688,42.37900161743164 65.10399627685547,50.88199996948242 C39.854000091552734,57.32899856567383 11.694999694824219,59.41600036621094 -18.06599998474121,57.316001892089844 C-84.17500305175781,52.652000427246094 -137.54299926757812,35.28900146484375 -148.8509979248047,8.85099983215332 C-150.281005859375,5.50600004196167 -149.52499389648438,2.177000045776367 -150.14999389648438,-2.7139999866485596z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-3'
                            transform="matrix(1,0,0,1,368.17401123046875,367.5780029296875)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,27.34000015258789,104.36399841308594)"
                            >
                                <path
                                    fill="rgb(113,177,119)"
                                    fillOpacity={1}
                                    d=" M-14.295000076293945,104.11399841308594 C-14.295000076293945,104.11399841308594 -27.09000015258789,96.37899780273438 -27.09000015258789,96.37899780273438 C13.395000457763672,31.476999282836914 -18.392000198364258,-97.427001953125 -18.722000122070312,-98.73999786376953 C-18.722000122070312,-98.73999786376953 -9.468000411987305,-104.11399841308594 -9.468000411987305,-104.11399841308594 C-8.076000213623047,-98.5459976196289 27.090999603271484,34.805999755859375 -14.295000076293945,104.11399841308594z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-4'
                            transform="matrix(1,0,0,1,334.27301025390625,107.9119873046875)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,93.13899993896484,133.38999938964844)"
                            >
                                <path
                                    fill="rgb(128,185,128)"
                                    fillOpacity={1}
                                    d=" M-81.66400146484375,-11.640999794006348 C-91.43199920654297,19.875 -92.88899993896484,39.70500183105469 -83.36699676513672,66.99199676513672 C-74.08100128173828,93.60099792480469 -51.79999923706055,132.56100463867188 -51.79999923706055,132.56100463867188 C-51.79999923706055,132.56100463867188 -23.643999099731445,133.13999938964844 2.568000078201294,122.84600067138672 C28.7810001373291,112.5530014038086 68.46299743652344,71.36900329589844 76.60299682617188,56.5359992980957 C84.74099731445312,41.702999114990234 92.76699829101562,11.637999534606934 91.51799774169922,-12.157999992370605 C90.61900329589844,-29.26099967956543 92.88899993896484,-38.297000885009766 75.8280029296875,-75.81600189208984 C58.766998291015625,-113.33499908447266 52.79100036621094,-122.625 48.39899826049805,-127.88200378417969 C44.007999420166016,-133.13999938964844 -18.430999755859375,-87.67400360107422 -41.90800094604492,-64.49099731445312 C-65.38600158691406,-41.30699920654297 -77.55799865722656,-24.889999389648438 -81.66400146484375,-11.640999794006348z"
                                />
                            </g>
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,93.21199798583984,160.8260040283203)"
                            >
                                <path
                                    fill="rgb(98,160,98)"
                                    fillOpacity={1}
                                    d=" M29.875999450683594,-85.85700225830078 C28.475000381469727,-85.75800323486328 20.982999801635742,-37.75299835205078 7.2820000648498535,8.064000129699707 C-3.4579999446868896,43.979000091552734 -19.270999908447266,78.93099975585938 -30.548999786376953,85.85800170898438 C-0.7549999952316284,62.36899948120117 15.524999618530273,27.1299991607666 21.52199935913086,-2.1419999599456787 C27.518999099731445,-31.413999557495117 32.375999450683594,-86.03299713134766 29.875999450683594,-85.85700225830078z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-5'
                            transform="matrix(1,0,0,1,392.5320129394531,384.82000732421875)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,54.452999114990234,41.87900161743164)"
                            >
                                <path
                                    fill="rgb(128,185,128)"
                                    fillOpacity={1}
                                    d=" M-54.45399856567383,34.952999114990234 C-52.60499954223633,23.687999725341797 -50.89699935913086,7.945000171661377 -44.75699996948242,-6.816999912261963 C-38.6150016784668,-21.577999114990234 -30.239999771118164,-35.28900146484375 -14.95199966430664,-39.13100051879883 C0.335999995470047,-42.97200012207031 19.6299991607666,-41.89500045776367 31.760000228881836,-41.15399932861328 C43.88999938964844,-40.41400146484375 53.768001556396484,-41.28300094604492 54.42300033569336,-37.94300079345703 C55.077999114990234,-34.60100173950195 45.21099853515625,-15.800000190734863 39.03499984741211,-2.1570000648498535 C32.85900115966797,11.484000205993652 16.770000457763672,24.87700080871582 7.050000190734863,30.78499984741211 C-2.6710000038146973,36.69300079345703 -10.210000038146973,41.972999572753906 -25.06999969482422,41.87799835205078 C-35.03200149536133,41.81399917602539 -54.45399856567383,34.952999114990234 -54.45399856567383,34.952999114990234z"
                                />
                            </g>
                        </g>
                        <g
                            className='g-6'
                            transform="matrix(1,0,0,1,198.49900817871094,255.42800903320312)"
                            opacity={1}
                            style={{ display: "block" }}
                        >
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,91.37300109863281,64.96099853515625)"
                            >
                                <path
                                    fill="rgb(137,202,137)"
                                    fillOpacity={1}
                                    d=" M91.37300109863281,51.83000183105469 C73.2490005493164,56.507999420166016 48.499000549316406,64.35800170898438 22.290000915527344,64.90899658203125 C-3.9189999103546143,65.45800018310547 -30.030000686645508,61.96099853515625 -45.90399932861328,41.56399917602539 C-61.77899932861328,21.167999267578125 -72.92500305175781,-8.491999626159668 -79.83699798583984,-27.180999755859375 C-86.7490005493164,-45.86899948120117 -94.58699798583984,-60.11399841308594 -90.00700378417969,-63.30699920654297 C-85.427001953125,-66.5 -50.69300079345703,-64.13200378417969 -26.141000747680664,-63.888999938964844 C-1.5880000591278076,-63.645999908447266 29.145999908447266,-48.36399841308594 44.43899917602539,-37.6879997253418 C59.733001708984375,-27.011999130249023 72.63999938964844,-19.19300079345703 82.3270034790039,3.1659998893737793 C88.82099914550781,18.15399932861328 91.37300109863281,51.83000183105469 91.37300109863281,51.83000183105469z"
                                />
                            </g>
                            <g
                                opacity={1}
                                transform="matrix(1,0,0,1,99.19000244140625,68.7020034790039)"
                            >
                                <path
                                    fill="rgb(92,162,92)"
                                    fillOpacity={1}
                                    d=" M-54.01300048828125,-34.57400131225586 C-59.09299850463867,-38.57099914550781 4.584000110626221,33.20000076293945 54.29999923706055,34.736000061035156 C-12.180000305175781,4.714000225067139 -45.02000045776367,-27.49799919128418 -54.01300048828125,-34.57400131225586z"
                                />
                            </g>
                        </g>
                    </g>
                </svg>
            </div>
            <span className='title'>Vegan</span>            
        </div> 
    )
}

export default Vegan